export default "__VITE_ASSET__B5fyDo8A__"